/**
 * Livraison Cloudinary optimisée (f_auto / q_auto / w_*).
 * Ne modifie pas les assets stockés ni les URLs en DB — transformation delivery only.
 */

const UPLOAD_MARKER = '/upload/'

/** Presets d’affichage Admin (largeur max delivery). */
export const CLOUDINARY_ADMIN_WIDTH = {
  thumb: 96,
  logo: 128,
  tile: 480,
  card: 640,
  hero: 1200,
}

/**
 * @param {unknown} url
 * @returns {boolean}
 */
export function isCloudinaryDeliveryUrl(url) {
  if (typeof url !== 'string' || !url) return false
  if (!/res\.cloudinary\.com/i.test(url)) return false
  return url.includes(UPLOAD_MARKER)
}

/**
 * @param {string} afterUpload
 */
export function hasCloudinaryTransforms(afterUpload) {
  if (!afterUpload || typeof afterUpload !== 'string') return false
  const first = afterUpload.split('/')[0] || ''
  if (!first) return false
  if (/^v\d+$/i.test(first)) return false
  if (first.includes(',')) return true
  return /^(f_|q_|w_|h_|c_|dpr_|e_|fl_|g_|l_|o_|r_|t_|x_|y_|z_|a_|b_|u_|pg_)/i.test(first)
}

/**
 * @param {string|null|undefined} url
 * @param {{ width?: number|string|null, quality?: number|string|null }} [options]
 * @returns {string|null|undefined}
 */
export function cloudinaryDeliveryUrl(url, options = {}) {
  if (url == null || url === '') return url
  if (typeof url !== 'string') return url
  if (!isCloudinaryDeliveryUrl(url)) return url

  const idx = url.indexOf(UPLOAD_MARKER)
  if (idx < 0) return url

  const before = url.slice(0, idx + UPLOAD_MARKER.length)
  const after = url.slice(idx + UPLOAD_MARKER.length)

  if (hasCloudinaryTransforms(after)) {
    return url
  }

  const widthRaw = options.width
  const width =
    widthRaw == null || widthRaw === ''
      ? null
      : Math.max(1, Math.round(Number(widthRaw)))

  if (width != null && Number.isNaN(width)) return url

  const quality = options.quality
  const qPart =
    quality == null || quality === '' || quality === 'auto'
      ? 'q_auto'
      : `q_${quality}`

  const parts = ['f_auto', qPart, 'c_limit']
  if (width != null) parts.push(`w_${width}`)

  return `${before}${parts.join(',')}/${after}`
}
